<template>
<transition name="fade">
  <div class="ui dimmer page" v-if="showBackDrop" style="display: block !important" :style="{ visibility: showBackDrop ? 'visible' : 'hidden', opacity: showBackDrop ? '1' : '0'}">
    <transition name="scale">
      <div class="ui center aligned middle aligned grid constatus">
        <div class="column">
          <div>
            <i class="bug huge icon red"></i>
            <h1>Ooops!</h1>
            <h3>It appears there has been an internal error.</h3>
            <h4>We are working to fix this problem.</h4>
            <button class="ui large circular green button" @click="onRefresh">
           <i class="refresh icon"></i>Retry</button>
            <div class="ui horizontal divider" style="color:white;">Or</div>
            <h3>Contact us, If the problem persists.</h3>
          </div>
        </div>
      </div>
    </transition>
  </div>
</transition>
</template>

<script>
export default {
  name: 'onerror',
  props: {},

  data() {
    return {
      showBackDrop: false,

    }
  },
  created() {

window.addEventListener("unhandledrejection", function (e) {
  console.log(e)
  console.warn("WARNING: Unhandled promise rejection."+ e.reason);
});

    window.onerror = (msg, src, line) => {
      console.log(msg);
      console.log(src)
      console.log(line)
      this.open();
      /*this.$server.rpc({
          method: 'log.add',
          args: {loc: this.$isMobile ? 'Mobile Web' : 'Web', msg: msg, stack: {url: src, line:line, err: msg}},
        }, true)
        .then((data) => {
        })
        .catch((error) => {
        }) */
      return true;
    };
    
  },
  mounted() {
    document.body.classList.add("dimmable");

  },
  methods: {
    open() {
      document.body.classList.add("dimmed");
      this.showBackDrop = true
    },
    close() {
      this.showBackDrop = false
      document.body.classList.remove("dimmed");
    },
    onRefresh () {
       window.location.reload()
    }
  }
}
</script>


<style>
.constatus {
  height: 100vh;
  color: #fff;
}

</style>



// WEBPACK FOOTER //
// OnError.vue?7ad1efd0